import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Input, Upload } from 'antd';

import { API_ROOT as BASE_URL, authenticatedUploadProps } from '@partsbadger/utils';

const FILE_URL = `${BASE_URL}/customer/files/`;

interface IProps {
    value: {
        id: number;
        filename: string;
        file: any;
        url: string;
        response: {
            id: number;
        };
    }[];
    handleChange: (value: any) => void;
}

interface IFileList {
    uid?: number;
    name?: string;
    status?: string;
    url?: any;
    response: {
        id: number;
        filename: string;
        file: any;
    };
}

const ExtraFile: React.FC<IProps> = ({ value, handleChange }) => {
    const [fileList, setFileList] = useState<IFileList[]>([]);

    const defaultFileList = value
        ?.filter(f => f)
        .map(file => {
            return {
                uid: file.id,
                name: file.filename,
                status: 'done',
                url: file.file,
                response: {
                    id: file.id,
                },
            };
        });

    useEffect(() => {
        const data = fileList?.map(file => {
            if (file.status === 'done') {
                return {
                    id: file.response.id,
                    filename: file.response.filename,
                    file: file.response.file,
                };
            }
        });

        if (data.length) {
            handleChange(data);
        }
    }, [fileList]);

    return (
        <>
            <Upload.Dragger
                name="file"
                {...authenticatedUploadProps(FILE_URL)}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                defaultFileList={defaultFileList}
                onChange={(info: any) => {
                    // const {status, response} = info.file;

                    setFileList([...info.fileList]);

                    // if (status === 'done') {
                    //     handleChange(response.id)
                    // }
                }}
                multiple
            >
                <Button>
                    <UploadOutlined /> Click to upload
                </Button>
            </Upload.Dragger>
        </>
    );
};

export default ExtraFile;
